
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthModal from './AuthModal';

export default function Login({ onLogin }) {
  const [showAuthModal, setShowAuthModal] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    if (token && user) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const handleAuthSuccess = () => {
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    const token = localStorage.getItem('token');
    
    if (token && userData) {
      const staffData = {
        id: userData.staffId || userData.id || userData.contact || userData.email,
        name: userData.name || userData.fullName || 'User',
        role: userData.role || 'employee',
        email: userData.email || userData.contact,
        staffId: userData.staffId || userData.employeeId || `EMP${Math.floor(Math.random() * 1000)}`
      };
      
      if (onLogin) {
        onLogin(staffData);
      }
      
      setShowAuthModal(false);
    }
  };

  const handleCloseModal = (isSuccess = false) => {
    setShowAuthModal(false);
    if (isSuccess) {
      handleAuthSuccess();
    }
  };

  return (
    <AuthModal 
      isOpen={showAuthModal} 
      onClose={handleCloseModal}
      initialForm="login"
    />
  );
}